/**
 * global service action types
 */
// start loading all service required params
export const RENDER_APP = 'RENDER_APP';
export const DESTROY_APP = 'DESTROY_APP';
export const DESTROY_APP_SUCCESS = 'DESTROY_APP_SUCCESS';
export const RESET_STORE = 'RESET_STORE';

// configuration loading indicator
export const SET_IS_CONFIGURATION_LOADED = 'SET_IS_CONFIGURATION_LOADED';

// main loading indicator
export const SET_IS_BASE_PARAMS_RECEIVED = 'SET_IS_BASE_PARAMS_RECEIVED';

// toggle app mounting to DOM
export const SET_IS_RENDERED = 'SET_IS_RENDERED';

// toggle app applied modulor theme
export const SET_IS_THEME_APPLIED = 'SET_IS_THEME_APPLIED';

// debug:
export const SET_USE_DEBUG_MODE = 'SET_USE_DEBUG_MODE';
export const SET_DEBUG_CONFIGURATION_VALUE = 'SET_DEBUG_CONFIGURATION_VALUE';

// toggle local game launch mode
export const SET_COMMON_APP_LOCAL_GAME_LAUNCH_MODE =
  'SET_COMMON_APP_LOCAL_GAME_LAUNCH_MODE';
export const SET_CASINO_APP_LOCAL_GAME_LAUNCH_MODE =
  'SET_CASINO_APP_LOCAL_GAME_LAUNCH_MODE';

export const DEBUG_STATUS = 'DEBUG';
export const ACTIVE_STATUS = 'ACTIVE';
export const DEFAULT_STATUS = ACTIVE_STATUS;

export const LOCALIZATION_INITIALIZED = 'LOCALIZATION_INITIALIZED';
